import Neighborhoods from './neighborhoods';
export default Neighborhoods;